const DISMISSED_STORAGE_KEY = 'locationAlertDismissed';
const RETRY_STORAGE_KEY_PREFIX = 'deliveryMarketRetry:';

const readList = (key: string): string[] => {
	try {
		return JSON.parse(window.sessionStorage.getItem(key) ?? '[]');
	} catch {
		return [];
	}
};

/** The alert is dismissed per browser session and per store + zip code combination. */
export const getDismissalKey = (storeId: string, zipCode: string) => `${storeId}|${zipCode}`;

export const isAlertDismissed = (dismissalKey: string): boolean =>
	typeof window !== 'undefined' && readList(DISMISSED_STORAGE_KEY).includes(dismissalKey);

export const markAlertDismissed = (dismissalKey: string) => {
	const dismissed = readList(DISMISSED_STORAGE_KEY);
	if (dismissed.includes(dismissalKey)) return;
	try {
		window.sessionStorage.setItem(
			DISMISSED_STORAGE_KEY,
			JSON.stringify([...dismissed, dismissalKey])
		);
	} catch {
		// Storage unavailable (private mode or quota): the alert just shows again next time.
	}
};

/** Geocoding is retried only once per session for each zip code. */
export const claimMarketRetry = (zipCode: string): boolean => {
	const key = `${RETRY_STORAGE_KEY_PREFIX}${zipCode}`;
	try {
		if (window.sessionStorage.getItem(key)) return false;
		window.sessionStorage.setItem(key, '1');
	} catch {
		return false;
	}
	return true;
};
